import { render, staticRenderFns } from "./roleCofing.vue?vue&type=template&id=11aaad8c"
import script from "./roleCofing.vue?vue&type=script&lang=js"
export * from "./roleCofing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11aaad8c')) {
      api.createRecord('11aaad8c', component.options)
    } else {
      api.reload('11aaad8c', component.options)
    }
    module.hot.accept("./roleCofing.vue?vue&type=template&id=11aaad8c", function () {
      api.rerender('11aaad8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleManage/roleCofing.vue"
export default component.exports